module.exports = __webpack_public_path__ + "static/media/item1.6c426583.jpg";